import AxiosInstance from "../Utils/axios/axiosConfig";

const getStockRecords = async (params,state='') => {
    if (params.page && params.size) {
      const start = (params.page - 1) * params.size;
      const end = start + params.size * 1;
      const status = state?'&status='+state:'';
      return AxiosInstance.get(
        `/inventory/stocks/?start=${start}&end=${end}${status}&sort_by=${params.sort_by}&sort_type=${params.sort_type}${status}`
      );
    } else {
      return AxiosInstance.get(`/inventory/stocks/?status=${params.status}`);
    }
  };
  export {
    getStockRecords
  }